// ブラウザの自動翻訳や拡張機能が 画面の文字を書き換えても、画面が止まらないようにする。
// Chrome の翻訳は文字を <font> で包み直すため、React が後から部品を外そうとしたときに
// 「Failed to execute 'removeChild' on 'Node'」で画面全体がエラーになる
// (2026-10 新井様の「分析・レポートのプレビューが開けない」件。英語のページと宣言していたため自動翻訳されていた)。
// 翻訳自体は index.html の lang="ja" translate="no" で止めているが、手動で翻訳した場合や
// 拡張機能による書き換えでも止まらないよう、対象が見つからないときは何もしないで続ける。
// 参考: https://github.com/facebook/react/issues/11538
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function removeChild(child) {
    if (child && child.parentNode !== this) return child;
    return originalRemoveChild.apply(this, arguments);
  };
  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function insertBefore(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) return newNode;
    return originalInsertBefore.apply(this, arguments);
  };
}
